import React from "react";
import Element from "./element";

/**
 * @typedef {Object} MKProps
 *
 * ### Identificação e comportamento base
 * @property {string} [name]              - Nome lógico do campo
 * @property {string} [label]             - Rótulo visível
 * @property {string} [type]              - Tipo do Element (controlado pelo MK)
 * @property {string} field             - Campo associado no modelo (CRUD)
 *
 * ### Entrada e saída
 * @property {any} [value]                - Valor atual
 * @property {(value:any)=>void} [change] - Quando o valor muda
 *
 * ### Layout e estilo
 * @property {string} [styleClass]        - Equivalente ao antigo className
 * @property {Object<string,any>} [style] - Estilos inline opcionais
 *
 * ### Estados visuais
 * @property {boolean} [disabled]
 * @property {boolean} [readonly]
 * @property {boolean} [required]
 * @property {boolean} [visible]
 *
 * ### Comportamentos adicionais
 * @property {string} [placeholder]
 * @property {string} [help]
 * @property {any} [mask]
 * @property {RegExp|string} [pattern]
 * @property {number} [min]
 * @property {number} [max]
 *
 * ### Estruturas dinâmicas
 * @property {Array<any>|Object} [options] - Para selects, radios etc.
 * @property {any} [children]
 *
 * ### Metadata e integração com CRUD
 * @property {Object<string,any>} [meta]
 * @property {string} [entity]
 *
 * ### Eventos simplificados
 * @property {(event:any)=>void} [click]
 * @property {(event:any)=>void} [blur]
 * @property {(event:any)=>void} [focus]
 *
 * ### Upload / Arquivos
 * @property {(file:any)=>void} [upload]
 * @property {Array<any>} [files]
 *
 * ### Componentes complexos
 * @property {Array<any>} [items]
 * @property {any} [config]
 *
 * ### Autocomplete / Busca
 * @property {(query:string)=>Promise<any[]>} [search]
 *
 * ### RichText / Editor
 * @property {string} [format]
 */


/**
 * @template {MKProps} P
 * @param {string} type
 * @returns {(props: P) => JSX.Element}
 */
const el = (type) => (props) => <Element isMaker type={type} {...props} />;

const MK = {
    Input: el("text"),
    Entity: el("entity"),
    If: el("if"),
    MultiCheck: el("multicheck"),
    Yaml: el("yaml"),
    Barcode: el("barcode"),
    Resizer: el("resizer"),
    Markdown: el("markdown"),
    Div: el("div"),
    PopUp: el("popup"),
    File: el("file"),
    Html: el("html"),
    Preview: el("preview"),
    Gravatar: el("gravatar"),
    Overlay: el("overlay"),
    Include: el("include"),
    Arrow: el("arrow"),
    Diff: el("diff"),
    RichText: el("richtext"),
    Link: el("link"),
    Calendar: el("calendar"),
    Text: el("text"),
    Period: el("period"),
    Map: el("map"),
    Button: el("button"),
    Switch: el("switch"),
    Checkbox: el("checkbox"),
    Radio: el("radio"),
    Carousel: el("carousel"),
    Slider: el("slider"),
    Group: el("group"),
    Timeline: el("timeline"),
    Card: el("card"),
    Icon: el("icon"),
    Output: el("output"),
    Upload: el("upload"),
    Step: el("step"),
    FileImport: el("fileimport"),
    Import: el("import"),
    Stepper: el("stepper"),
    Toggle: el("toggle"),
    Range: el("range"),
    Flow: el("flow"),
    Select: el("select"),
    Complete: el("complete"),
    Code: el("code"),
    JSON: el("json"),
    SQL: el("sql"),
    Editor: el("editor"),
    Chart: el("chart"),
    Define: el("define"),
    Grid: el("list"),
    List: el("list"),
    Repeat: el("repeat"),
    Column: el("column"),
    View: el("view"),
    Crud: el("crud"),
    Tabs: el("tabs"),
    Tab: el("tab"),
    Defaults: el("defaults"),
    Tooltip: el("tooltip"),
    Img: el("img"),
    Textarea: el("textarea"),
    Datetime: el("datetime"),
    Buttons: el("buttons"),
    Dropzone: el("dropzone"),
    Render: el("render"),
    IntegrationList: el("integrationlist"),
    Emoji: el("emoji"),
    Log: el("log"),
};

// Depois de declarar o MK:
Object.keys(MK).forEach((key) => {
    const fn = MK[key];

    fn.defaultType = key;
});


export default MK;
